<template>
  <div :style="{ height, width }" id="EchartsSuy" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
      return {
          timer:""

      }
  },
  mounted(){
    // this.startTimer() 
      setTimeout(this.startTimer, 0);
  },
  methods:{
     _dashed() {
      let dataArr = [];
      for (var i = 0; i < 100; i++) {
          if (i % 2 === 0) {
              dataArr.push({
                  name: (i + 1).toString(),
                  value: 20,
                  itemStyle: {
                      normal: {
                          color: 'rgb(0,255,255,.3)',
                      }
                  }
              })
          } else {
              dataArr.push({
                  name: (i + 1).toString(),
                  value: 20,
                  itemStyle: {
                      normal: {
                          color: 'rgb(0,0,0,0)',
                          borderWidth: 1,
                          borderColor: "rgba(0,255,255,1)"
                      }
                  }
              })
          }

      }
      return dataArr
    },
     doing() {
      let value = 80.2;
      let title = '溯源查询率';
      var echarts = require('echarts');
       var myCharts = echarts.init(document.getElementById('EchartsSuy'));
       console.log(this._dashed())
      let option = {
            title: {
              text: '{a|' + value + '}{b|%' + '}\n{c|' + title + '}',
              x: 'center',
              y: 'center',
              textStyle: {
                  rich: {
                      a: {
                          fontSize: 36,
                          color: '#fff',
                          fontWeight:'600',
                      },
                      b: {
                          fontSize: 26,
                          color: '#fff',
                          padding: [0, 0, 0, 5]
                      },
                      c: {
                          fontSize: 26 ,
                          color: '#fff',
                          padding: [2, 0]
                      }
                  }
              }
          },
          series: [
              {
                  type: 'gauge',
                  radius: '76%',
                  clockwise: false,
                  startAngle: '90',
                  endAngle: '-269.9999',
                  splitNumber: 30,
                  detail: {
                      offsetCenter: [0, -30],
                      formatter: ' '
                  },
                  pointer: {
                      show: false
                  },
                  axisLine: {
                      show: true,
                      lineStyle: {
                          color: [
                              [0, '#2CFAFC'],
                              [(100-value) / 100, '#0ff'],
                              [1, '#0f232e']
                          ],
                          width: 16
                      }
                  },
                  axisTick: {
                      show: false
                  },
                  splitLine: {
                      show: true,
                      length:112,
                      lineStyle: {
                          shadowBlur: 5,
                          shadowColor: 'rgba(0, 255, 255, 0.5)',
                          shadowOffsetY:'0',
                          color: '#020f18',
                          width: 2
                      }
                  },
                  axisLabel: {
                      show: false
                  }
              },
              {
                  type: 'pie',
                  radius: ['56%', '58%'],
                  startAngle: '90',
                  hoverAnimation: false,
                  clockWise: false,
                  itemStyle: {
                      normal: {
                          color: '#f00'
                      }
                  },
                  label: {
                      show: false
                  },
                   
                  data: this._dashed()
              }, 
              {
                  type: 'pie',
                  radius: [0, '50%'],
                  hoverAnimation: false,
                  clockWise: false,
                  itemStyle: {
                      normal: {
                          shadowBlur: 20,
                          shadowColor: '#000',
                          color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                              offset: 0,
                              color: '#10E6B7',
                          }, {
                              offset: 1,
                              color: '#0F92AA'
                          }])
                      }
                  },
                  label: {
                      show: false
                  },
                  data: [100]
              },
              {
                  type: 'pie',
                  radius: ['80%', '82%'],
                  hoverAnimation: false,
                  clockWise: false,
                  itemStyle: {
                      normal: {
                          shadowBlur: 20,
                          shadowColor: 'rgba(0, 255, 255,.5)',
                          color: '#0f232e'
                      }
                  },
                  label: {
                      show: false
                  },
                  data: [100]
              },
              {
                  type: 'pie',
                  radius: ['88%', '89.5%'],
                  hoverAnimation: false,
                  clockWise: false,
                  itemStyle: {
                      normal: { 
                          shadowBlur: 20,
                          shadowColor: 'rgba(0, 255, 255,.8)',
                            color: 'rgba(15, 35, 46,1)',
                      }
                  },
                  label: {
                      show: false
                  },
                  data: [100]
              },
          ]
        };

        
        // let option1 = myCharts.getOption();
      option.series[1].startAngle = option.series[1].startAngle - 1;
        myCharts.setOption(option);
    },
    startTimer() {
      // clearInterval(this.timer);
      // this.doing()
         setInterval(this.doing, 1000);
    },
  }
}
</script>
<style lang="less">
  .min-body{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #010827;
  }
  
</style>
